import { isEmpty } from "lodash";

export type ShipmentLabelData = {
  shipmentNumber?: string | null;
  referenceNumbers?: (string | null)[] | null;
};

/**
 * Formats a shipment label with the shipment number and reference numbers
 * @param shipment - Shipment data containing shipmentNumber and referenceNumbers
 * @returns Formatted shipment label string
 */
export const formatShipmentLabel = (shipment: ShipmentLabelData): string => {
  const referenceNumbers = shipment.referenceNumbers?.filter(
    (v) => !isEmpty(v)
  );

  if (referenceNumbers?.length) {
    return `${shipment.shipmentNumber} / ${referenceNumbers.join(", ")}`;
  }

  return shipment.shipmentNumber || "";
};
